import PurchasesNewEvent from './Index.vue';

export default PurchasesNewEvent;



// WEBPACK FOOTER //
// ./src/pages/profile/views/purchases/pages/purchases-new-event/index.ts